import React from 'react';
import { Empty as AntEmpty, EmptyProps as AntEmptyProps } from 'antd';
import { createUseStyles } from 'react-jss';
import { ThemeType } from 'src/theming/jssTypes';

export interface EmptyProps extends AntEmptyProps {
  className?: string;
}

interface EmptyComponent extends React.FC<EmptyProps> {
  PRESENTED_IMAGE_DEFAULT: typeof AntEmpty.PRESENTED_IMAGE_DEFAULT;
  PRESENTED_IMAGE_SIMPLE: typeof AntEmpty.PRESENTED_IMAGE_SIMPLE;
}

const useStyles = createUseStyles((theme: ThemeType) => ({
  emptyDefault: {
    padding: theme.spacing[4],
    '& .ant-empty-image': {
      height: 'auto',
      '& svg': {
        color: theme.color.semantic.text.secondary,
      },
    },
    '& .ant-empty-description': {
      color: theme.color.semantic.text.soft,
      fontSize: theme.typography.fontSize.sm,
      fontWeight: theme.typography.fontWeight.regular,
      marginTop: theme.spacing[2],
    },
  },
  emptySimple: {
    padding: theme.spacing[4],
    '& .ant-empty-image': {
      height: 'auto',
      '& svg': {
        color: theme.color.semantic.text.soft,
      },
    },
    '& .ant-empty-description': {
      color: theme.color.semantic.text.soft,
      fontSize: theme.typography.fontSize.sm,
      fontWeight: theme.typography.fontWeight.regular,
      marginTop: theme.spacing[2],
    },
  },
}));

const EmptyComponent: React.FC<EmptyProps> = ({
  image = AntEmpty.PRESENTED_IMAGE_DEFAULT,
  className = '',
  ...rest
}) => {
  const classes = useStyles();

  const isSimple = image === AntEmpty.PRESENTED_IMAGE_SIMPLE;
  const emptyClass = isSimple ? classes.emptySimple : classes.emptyDefault;

  const combinedClassName = `${emptyClass} ${className}`.trim();

  return (
    <AntEmpty
      image={image}
      {...rest}
      className={combinedClassName}
    />
  );
};

// Create the typed component with static properties
const Empty = EmptyComponent as EmptyComponent;

// Export constants from AntEmpty for convenience
Empty.PRESENTED_IMAGE_DEFAULT = AntEmpty.PRESENTED_IMAGE_DEFAULT;
Empty.PRESENTED_IMAGE_SIMPLE = AntEmpty.PRESENTED_IMAGE_SIMPLE;

export default Empty;
